// extracted by mini-css-extract-plugin
export default {"serviceComboSearchSettings":"UserAddNewServiceComboComponent_serviceComboSearchSettings__QaNEe","sites-column":"UserAddNewServiceComboComponent_sites-column__wF9SE"};